<template>
    <div>
        <v-dialog v-model="dialog" max-width="1000">
            <template v-slot:activator="{ on, attrs }">
                <div>
                    <label for="agent_voice" v-on="on">{{ label }}</label>
                    <div
                        v-if="voices.length > 0"
                        id="agent_voice"
                        class="justify-space-between align-center cursor-pointer v-input__slot px-0 py-0"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <div class="d-flex align-center px-1" >
                            <v-avatar v-if="selectedVoice" size="24" class="mr-3">
                                <img :src="selectedVoice.avatar_url" :alt="selectedVoice.voice_name" />
                            </v-avatar>
                            <span v-if="selectedVoice">{{ selectedVoice.voice_name }}</span>
                            <span v-else class="grey--text">{{ placeholder }}</span>
                        </div>
                        <v-btn v-if="selectedVoice" class="pa-1 ma-0" flat icon @click.stop="playAudio(selectedVoice.preview_audio_url)">
                            <v-icon>mdi-volume-high</v-icon>
                        </v-btn>
                        <v-icon v-else class="mr-4 grey--text">mdi-chevron-up-down</v-icon>
                    </div>
                </div>
            </template>

            <v-card>
                <v-card-title>
                    {{ placeholder }}
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search by name"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>

                <!-- :custom-filter="nameFilter" -->
                <!--  -->
                <v-data-table
                    v-if="voices.length > 0"
                    :headers="headers"
                    :items="voices"
                    :search="search"
                    class="elevation-1"
                    :rows-per-page-items="[
                        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
                        10,
                        25,
                    ]"
                >
                    <template v-slot:items="{ item }">
                        <td style="width: 20px;">
                            <v-btn icon :disabled="currentPlaying === item.preview_audio_url" @click="playAudio(item.preview_audio_url)">
                                <v-icon>{{ currentPlaying === item.preview_audio_url ? 'mdi-pause-circle' : 'mdi-play-circle' }}</v-icon>
                            </v-btn>
                        </td>
                        <td>
                            <div class="d-flex align-center">
                                <v-avatar size="32" class="mx-3">
                                    <img :src="item.avatar_url" :alt="item.voice_name" />
                                </v-avatar>
                                <span class="capitalize">{{ item.voice_name }}</span>
                            </div>
                        </td>
                        <td>{{ item.accent }}</td>
                        <td>{{ item.provider }}</td>
                        <td>{{ item.gender }}</td>
                        <td>{{ item.age }}</td>
                        <td>
                            <v-btn
                                :outlined="item.voice_id !== selectedVoice.voice_id"
                                :disabled="item.voice_id === selectedVoice.voice_id"
                                @click="selectVoice(item)"
                                block
                            >
                                <v-icon v-if="item.voice_id === selectedVoice.voice_id" left>mdi-check</v-icon>
                                {{ item.voice_id === selectedVoice.voice_id ? 'Selected' : 'Select' }}
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
              
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'VoicesOptions',
    props: {
        value: {
            type: String,
            default: '11labs-Alice'
        },
        label: {
            type: String,
            default: 'Select a Voice'
        },
        placeholder: {
            type: String,
            default: 'Select a Voice'
        },
    },
    data() {
        return {
            dialog: false,
            search: '',
            voices: [],
            selectedVoice: {},
            currentPlaying: null,
            audio: new Audio(),
            headers: [
                { text: '', value: 'preview_audio_url', sortable: false, width: '20px' },
                { text: 'Name', value: 'voice_name' },
                { text: 'Accent', value: 'accent' },
                { text: 'Provider', value: 'provider' },
                { text: 'Gender', value: 'gender' },
                { text: 'Age', value: 'age' },
                { text: 'Actions', value: 'actions', sortable: false }
            ]
        }
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.updateSelectedVoice()
            }
        }
    },
    methods: {
        async getVoices() {
            try {
                const {data} = await this.$http_voice.get('/voices/')
                this.voices = data.data
                this.updateSelectedVoice()
            } catch (error) {
                console.error('Error fetching voices:', error)
            }
        },
        updateSelectedVoice() {
            const voice = this.voices.find(item => item.voice_id === this.value)
            this.selectVoice(voice || this.voices[0], false)
        },
        playAudio(url) {
            this.audio.pause()
            this.audio.src = url
            this.audio.play()
            this.audio.onended = () => this.currentPlaying = null
            this.currentPlaying = url
        },
        selectVoice(voice, changed = true) {
            this.selectedVoice = voice
            if (changed) {
                this.$emit('input', voice.voice_id)
                this.dialog = false
            }
        },
        nameFilter(value, search) {
            return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
        }
    },
    mounted() {
        this.getVoices()
    }
}
</script>

<style scoped>
.capitalize {
    text-transform: capitalize;
}
.cursor-pointer {
    cursor: pointer;
}
</style>
